import { Button } from 'antd';
import styled from 'styled-components';

export const ModalContainer = styled.div``;

export const CustomButton = styled(Button)`
  transition: filter 0.2s;

  &:hover {
    filter: brightness(0.9);
  }
`;

export const Content = styled.div`
  max-height: 73vh;

  display: flex;
  flex-direction: column;

  > h1 {
    width: 100%;
    color: ${({ theme }) => theme.background};
    font-weight: 600;

    background: ${({ theme }) => theme.menuButton};
    padding: 10px;
  }

  > span {
    overflow-y: scroll;

    > div {
      padding-left: 40px;
    }
  }

  @media (max-width: 540px) {
    > span {
      > div {
        padding-left: 20px;
      }
    }
  }

  @media (max-width: 280px) {
    > span {
      > div {
        padding-left: 10px;
      }
    }
  }
`;
